
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("la2MJ", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $0aa25fa4ffdb1f12$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButton", () => $0aa25fa4ffdb1f12$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "default", () => $0aa25fa4ffdb1f12$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $dAv2D = parcelRequire("dAv2D");

var $lRq8t = parcelRequire("lRq8t");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

var $1KdDN = parcelRequire("1KdDN");

var $lQyw6 = parcelRequire("lQyw6");

var $25akk = parcelRequire("25akk");
const $0aa25fa4ffdb1f12$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAv2D))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $lQyw6.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $lQyw6.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0aa25fa4ffdb1f12$var$ShareButtonBase = (0, $bQWwW.lazyAfterPaint)(()=>(parcelRequire("eWUa7")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $0aa25fa4ffdb1f12$export$e980dfbc2840e8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $25akk.ShareButtonAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0aa25fa4ffdb1f12$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0aa25fa4ffdb1f12$var$ShareButtonBase, props))));
var $0aa25fa4ffdb1f12$export$2e2bcd8739ae039 = $0aa25fa4ffdb1f12$export$e980dfbc2840e8bc;

});
parcelRegister("dAv2D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e46b7569d180ef1$var$_react = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9e46b7569d180ef1$var$_share = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("iePme")));

var $9e46b7569d180ef1$var$_share2 = $9e46b7569d180ef1$var$_interopRequireDefault((parcelRequire("4jCd5")));
function $9e46b7569d180ef1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e46b7569d180ef1$var$ShareIcon = (props)=>/*#__PURE__*/ $9e46b7569d180ef1$var$_react.default.createElement($9e46b7569d180ef1$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $9e46b7569d180ef1$var$_share2.default
    }, props));
$9e46b7569d180ef1$var$ShareIcon.Name = 'ShareIconMigration';
var $9e46b7569d180ef1$var$_default = module.exports.default = $9e46b7569d180ef1$var$ShareIcon;

});
parcelRegister("4jCd5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32469378f409d14d$var$_react = $32469378f409d14d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $32469378f409d14d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32469378f409d14d$var$ShareIcon = (props)=>/*#__PURE__*/ $32469378f409d14d$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props));
$32469378f409d14d$var$ShareIcon.displayName = 'ShareIcon';
var $32469378f409d14d$var$_default = module.exports.default = $32469378f409d14d$var$ShareIcon;

});


parcelRegister("lQyw6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e033b89304d7d864$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e033b89304d7d864$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("25akk", function(module, exports) {

$parcel$export(module.exports, "ShareButtonAnalyticsWrapper", () => $33efcf856c361e33$export$e86cfe752403a1e4);

var $eJOHy = parcelRequire("eJOHy");

var $eUaD0 = parcelRequire("eUaD0");

var $kQnVX = parcelRequire("kQnVX");

var $gZTP9 = parcelRequire("gZTP9");

var $7jTnu = parcelRequire("7jTnu");

var $2aY2d = parcelRequire("2aY2d");

var $f2JN3 = parcelRequire("f2JN3");

var $4xbv3 = parcelRequire("4xbv3");

var $ln6Iy = parcelRequire("ln6Iy");
const $33efcf856c361e33$var$BaseShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $2aY2d.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $ln6Iy.TEAM_MANAGED_PROJECT) : (0, $ln6Iy.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $kQnVX.getUserLocation)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $eJOHy.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eUaD0.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $33efcf856c361e33$export$e86cfe752403a1e4 = (0, $f2JN3.componentWithCondition)(()=>(0, $7jTnu.fg)('jsw-smart-access-extended-analytics-enabled'), $33efcf856c361e33$var$BaseShareButtonAnalyticsWrapper, (0, $eJOHy.Fragment));

});

parcelRegister("eWUa7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("lJGjE")
]).then(()=>parcelRequire('k0hQy'));

});



$parcel$global.rlb("4mJUh")
//# sourceMappingURL=rll-async.4b3dcd6e.js.map
